import { useEffect, useState } from "react";

type CrmxTheme = "light" | "dark";

function storedTheme(): CrmxTheme {
  if (typeof window === "undefined") return "light";
  return localStorage.getItem("crmx-theme") === "dark" ? "dark" : "light";
}

export function ThemeToggle() {
  const [theme, setTheme] = useState<CrmxTheme>(storedTheme);

  useEffect(() => {
    const inheritedV1Dark = document.documentElement.classList.contains("dark");

    return () => {
      delete document.documentElement.dataset.theme;
      document.documentElement.classList.toggle("dark", inheritedV1Dark);
    };
  }, []);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("crmx-theme", theme);
  }, [theme]);

  return (
    <button
      className="crmx-v2-theme-toggle"
      type="button"
      aria-pressed={theme === "dark"}
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
    >
      ◐ Dark
    </button>
  );
}
